{
  "common": {
    "save": "Speichern",
    "cancel": "Abbrechen",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "search": "Suchen",
    "loading": "Wird geladen...",
    "yes": "Ja",
    "no": "Nein",
    "language": "Sprache",
    "settings": "Einstellungen",
    "logout": "Abmelden",
    "today": "Heute",
    "yesterday": "Gestern",
    "all": "Alle",
    "saved": "Gespeichert"
  },
  "sidebar": {
    "dashboard": "Übersicht",
    "newOrder": "Neue Bestellung",
    "kitchen": "Küche",
    "dispatch": "Lieferung",
    "restaurant": "Restaurant",
    "products": "Produkte",
    "analytics": "Analyse",
    "employees": "Mitarbeiter"
  },
  "profile": {
    "title": "Mein Profil",
    "firstName": "Vorname",
    "lastName": "Nachname"
  },
  "attendance": {
    "arrive": "Ankunft",
    "leave": "Abreise"
  }
}
